module.exports = __webpack_public_path__ + "img/file-image.a92cb616.svg";